import { AccessGrant, Mutation } from 'graphql/generated/graphqlTypes';
import { generateMockAccessGrant } from 'mocks/graphqlMocks/accessGrant';
import { removeFields } from 'mocks/graphqlMocks/removeFields';
import { generateMockWeekSchedule } from 'mocks/graphqlMocks/weekSchedule';
import { generateMockWeekScheduleDay } from 'mocks/graphqlMocks/weekScheduleDay';

export function mockedUpdateAccessGrant(updateAccessGrant: AccessGrant): Pick<Mutation, 'updateAccessGrant'> {
  return {
    updateAccessGrant
  };
}

const fieldsToRemoveFromAccessGrant: (keyof AccessGrant)[] = [
  'doors',
  'doorIds',
  'isOfficeModeEnabled',
  'locations',
  'locationIds',
  'name',
  'tenantId'
];

export const mockedUpdateAccessGrantForMutation1 = mockedUpdateAccessGrant(
  removeFields(
    generateMockAccessGrant({
      id: 'mockedAccessGrantWithDays',
      accessSchedule: generateMockWeekSchedule({
        weekDays: [generateMockWeekScheduleDay({ dayName: 'monday', from: '08:00', to: '21:00' })]
      })
    }),
    fieldsToRemoveFromAccessGrant
  )
);

export const mockedUpdateAccessGrantForMutation2 = mockedUpdateAccessGrant(
  removeFields(
    generateMockAccessGrant({
      id: 'mockedAccessGrantWithDays5',
      accessSchedule: generateMockWeekSchedule({
        weekDays: [
          generateMockWeekScheduleDay({ dayName: 'sunday', to: '08:00', from: '21:00' }),
          generateMockWeekScheduleDay({ dayName: 'saturday', to: '08:00', from: '21:00' })
        ]
      })
    }),
    fieldsToRemoveFromAccessGrant
  )
);
